import Calendar from "views/Calendar/Calendar";
import Chat from "views/Chat/Chat";
import TableList from "views/Candidates/Tables.jsx";
import UserPage from "views/user/User.jsx";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Example from "views/Posts/Post";
import InternPage from "views/interns/internship";
import Switcher from "views/interns/Switcher";
// import Settings from "views/Settings";
import TabNavigation from "views/Posts/TabNavigation";
import CandidatesInternsTable from "views/Candidates/listCandidateInterns";
import Dataimport from "views/Candidates/dataimport";
import PostPage from "views/Posts/Post";
import PostPage2 from "views/ScrapedPosts/Post";
import ApplicationsList from "views/user/ApplicationSpontaneeList";
import QuizCreator from "../src/views/quiz/QuizCreator";
import Dashboard from "views/Dashboard/Dashboard";
import RecruiterDashboard from "views/carnivals/recruiter/RecruiterDashboard";
import EmailTemplates from "views/Emailing/EmailTemplates";
import PostDetails from "views/Posts/PostDetails";
import Settings from "views/Settings";
import TourTest from "views/TourTest/TourTest";
import BeaconTest from "views/BeaconTest/BeaconTest";
import { Routes, Route, Navigate } from "react-router-dom";
import PostDetailsScraped from "views/ScrapedPosts/PostDetailsScraped";
import dashboard_icon from '../src/assets/img/overview_icon.svg'
import user_profile_icon from '../src/assets/img/user_profile_icon.svg'
import published_offers_icon from '../src/assets/img/published_offers_icon.svg'
import messages_icon from '../src/assets/img/messages_icon.svg'
import data_scraping_icon from '../src/assets/img/data_scraping_icon.svg'
import spontaneous_icon from '../src/assets/img/spontaneous_icon.svg'
import calendar_icon from '../src/assets/img/calendar_icon.svg'
import data_import_icon from '../src/assets/img/data_import_icon.svg'
import my_data_icon from "../src/assets/img/my_data_icon.svg";
import model_email_icon from "../src/assets/img/modele_email_icon.svg";
import NewPostDetails from "views/Posts/newPostDetails";

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: dashboard_icon,
    component: <Dashboard />,
    layout: "/talent",
  },
  {
    path: "/user-page",
    name: "User Profile",
    icon: user_profile_icon,
    component: <UserPage />,
    layout: "/talent",
  },
  {
    path: "/post",
    name: "posts",
    icon: published_offers_icon,
    component: (
      <Routes>
        <Route index element={<Navigate to="PostDetails" replace />} />
        <Route path="PostDetails/*" element={<PostPage />} />
        <Route path=":id" element={<NewPostDetails />} />
        <Route path="scraped/*" element={<PostPage2 />} />
        <Route path="scraped/:id" element={<NewPostDetails />} />
      </Routes>
    ),
    layout: "/talent",
    basePath: "/post"
  },
  {
    path: "/listall",
    name: "Users List",
    icon: data_import_icon,
    component: <CandidatesInternsTable />,
    layout: "/talent",
  },
  {
    path: "/dataimport",
    name: "Import Data",
    icon: my_data_icon,
    component: <Dataimport />,
    layout: "/talent",
  },
  {
    path: "/candidature_spontanee_list",
    name: "Spontaneous",
    icon: spontaneous_icon,
    component: <ApplicationsList />,
    layout: "/talent",
  },
  {
    path: "/Chat",
    name: "Chat",
    icon: messages_icon,
    component: <Chat />,
    layout: "/talent",
  },
  {
    path: "/calendar",
    name: "Calendar",
    icon: calendar_icon,
    component: <Calendar />,
    layout: "/talent",
  },
  {
    path: "/emailing",
    name: "Email Templates",
    icon: model_email_icon,
    component: <EmailTemplates />,
    layout: "/talent",
  },
  // {
  //   path: "/settings",
  //   name: "Settings",
  //   icon: "fas fa-cog",
  //   component: <Settings />,
  //   layout: "/talent",
  // },
 
  // {
  //   path: "/carnavals",
  //   name: "Carnavals", // Will be translated dynamically in the component
  //   icon: "fas fa-handshake",
  //   component: <RecruiterDashboard />,
  //   layout: "/talent",
  // },
];

export default routes;